import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import Profile from '@/pages/Profile';
import SetupDetail from '@/pages/SetupDetail';
import Leaderboard from '@/pages/Leaderboard';
import PublicUserProfile from '@/pages/PublicUserProfile';
import ExchangeSettings from '@/pages/ExchangeSettings';
import ExchangeDashboard from '@/pages/ExchangeDashboard';
import Admin from '@/pages/Admin';
import TradingHistory from '@/pages/TradingHistory';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/setup/:setupId" element={<SetupDetail />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/user/:userId" element={<PublicUserProfile />} />
          <Route path="/exchanges" element={<ExchangeSettings />} />
          <Route path="/exchanges-dashboard" element={<ExchangeDashboard />} />
          <Route path="/trading-history" element={<TradingHistory />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>,
);
